import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Toolbar } from "@mui/material";

import AdminHeader from "./AdminHeader";
import AdminSidebar from "./AdminSidebar";

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100vw",
        minHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* SIDEBAR */}
      <AdminSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      {/* MAIN CONTENT */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0, // IMPORTANT: prevents overflow gap
          display: "flex",
          flexDirection: "column",
          transition: "0.3s ease",
        }}
      >
        <AdminHeader
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />

        {/* Spacer for fixed header */}
        <Toolbar />

        {/* PAGE CONTENT */}
        <Box
          sx={{
            flexGrow: 1,
            px: 3,
            py: 2,
            overflowY: "auto",
            backgroundColor: "#F8FAFC",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
